<template>
  <div class="top">
    <div v-for="(item, index) in accountInfo" :key="index" class="account">
      <span>{{ item.label }}</span>
      <span class="info">{{ item.content }}</span>
      <span class="operation" v-if="item.edit" @click="editAccount(item)">修改</span>
    </div>
  </div>
</template>

<script>
export default {
  inject: {
    editAccount: 'edit',
  },
  data() {
    return {
      accountInfo: [
        {
          label: '联系邮箱',
          prop: 'email',
          content: 'jiamo@chinachdu.com',
          edit: true,
        },
        {
          label: '联系手机',
          prop: 'phone',
          content: 'jiamo@chinachdu.com',
          edit: true,
        },
        {
          label: '姓' + '\xa0\xa0\xa0\xa0\xa0\xa0' + '名',
          prop: 'name',
          content: 'Jiamo',
          edit: true,
        },
        {
          label: '登陆密码',
          prop: 'oldPassword',
          content: 'jiamo@chinachdu.com',
          edit: true,
        },
        {
          label: '账号角色',
          prop: 'role',
          content: 'jiamo@chinachdu.com',
          edit: true,
        },
        {
          label: '创建时间',
          content: 'jiamo@chinachdu.com',
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.top {
  padding: 30px 33px;
}
.account {
  display: inline-block;
  width: 50%;
  margin-bottom: 30px;
}
.info {
  display: inline-block;
  width: 130px;
  padding: 0 30px 0 40px;
}
.operation {
  color: #4359b7;
  cursor: pointer;
}
</style>
